import { Alert, Box, Button, IconButton, Modal, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import { usePathContext } from "./PathInfo";
import { useTreeModifyContext } from "./TreeDataContext";

export function RemoveGamePieceButton() {
  const { path } = usePathContext();
  const { removeAtPath } = useTreeModifyContext();
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  function handleConfirmRemovePrompt() {
    setIsModalOpen(false);
    removeAtPath(path);
  }

  let gamePieceName = path.at(-1)!;
  if (
    gamePieceName === "root" ||
    gamePieceName === "dims" ||
    gamePieceName.startsWith("__card") ||
    gamePieceName.startsWith("deck-")
  ) {
    return <></>;
  }

  return (
    <>
      {isModalOpen && (
        <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <Box className={"dynamic-modal"}>
            <Box sx={{ margin: "10px" }}>
              <Box className="vertical-flex">
                <Typography variant={"h5"}>Confirm deletion? </Typography>
                <Alert severity="warning">
                  <Typography>Are you sure you want to remove "{gamePieceName}"?</Typography>
                </Alert>
                <Box className="horizontal-flex">
                  <Box className={"flex-filler"}></Box>
                  <Button variant={"contained"} color={"success"} onClick={() => setIsModalOpen(false)}>
                    Cancel
                  </Button>
                  <Button variant={"contained"} color={"error"} onClick={() => handleConfirmRemovePrompt()}>
                    Remove
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      )}

      <IconButton color={"error"} onClick={(_) => setIsModalOpen(true)}>
        <DeleteIcon />
      </IconButton>
    </>
  );
}
